module.exports = __webpack_public_path__ + "static/assets/de9ae687b647bf9a137a3f447bacbce1.svg";